import type { AxiosInstance } from "axios";
import { EventIdPublic } from "@shared/schemas/branded-id.schemas";

const NETWORK_API_PATH = "/api/v1/admin/network";

export function createNetworkAdminApi(apiClient: AxiosInstance) {
  return {
    async getNetwork(): Promise<unknown> {
      const response = await apiClient.get(NETWORK_API_PATH);
      return response.data;
    },

    // A read, though each query costs model calls: the ask is classified and
    // embedded, and the top candidates judged.
    async search(
      query: string,
      eventIdPublic: EventIdPublic | null,
      deep: boolean,
    ): Promise<unknown> {
      const response = await apiClient.get(`${NETWORK_API_PATH}/search`, {
        params: {
          query,
          ...(eventIdPublic !== null && {
            eventIdPublic: EventIdPublic.unwrap(eventIdPublic),
          }),
          ...(deep && { deep: "true" }),
        },
      });
      return response.data;
    },
  };
}
